<template>
  <div>
    <Header></Header>
    <div id="main">
      <div class="container">
        <div class="row">
          <h2>Notificações</h2>
        </div>
        <div class="row notifications-list">
          <div class="col-md-12" v-if="notifications && notifications.length > 0">
            <b-list-group>

              <b-list-group-item class="flex-column align-items-start" :class="{'new' : !n.wasReaded}" v-for="(n, k) in notifications" :key="n.NotificationId">
                <div class="d-flex w-100 justify-content-between">
                  <h5 class="mb-1">{{n.title}}</h5>
                  <small>{{getTimeAgo(n.createdAt)}}</small>
                </div>

                <div class="mt-2 mb-2">
                  <img :src="n.image" />
                </div>

                <p class="mb-1">
                  {{n.content}}
                </p>

                <p class="mt-2">
                  <a target="_blank" :href="n.link">Acessar URL</a>
                </p>
                
                <button class="btn btn-danger float-right" @click="deleteNotification(n.NotificationId)">Apagar</button>

                <button v-if="!n.wasReaded" id="markAsRead" class="btn btn-success float-right" @click="markAsRead(n.NotificationId, k)">Lido</button>
              </b-list-group-item>

            </b-list-group>
          </div>
          <div class="col-md-12" v-else>
            <h3>Não há notificações disponíveis.</h3>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
    <Loading v-if="loading"></Loading>
  </div>
</template>

<script>

import Header from './includes/Header'
import Footer from './includes/Footer'
import Loading from './includes/Loading'
import auth from '../services/auth'
import Functions from '../utils/functions'
import { API } from '../services/api'

export default {
  name: 'Profile',
  components: {
    Header,
    Footer,
    Loading,
  },
  data () {
    return {
      loading: true,
      user: false,
      notifications: null,
    }
  },
  created (){
    this.loadProfile();
    this.loadNotifications();
  },
  methods: {
    loadProfile(){
      this.$http.get(API.Profile.profile, {headers: auth.getHeaders()}).then((response) => {
        this.user = response.body.user;
        this.loading = false;
      });
    },
    loadNotifications(){
      this.$http.get(API.Notifications.list, {headers: auth.getHeaders()}).then((result) => {
        this.notifications = result.body.notifications;
        this.notifications.sort(function(x, y){
          return y.createdAt - x.createdAt;
        })
      });
    },
    markAsRead(NotificationId, key){
      this.$set(this.notifications[key], 'wasReaded', true);
      this.$http.post(API.Notifications.read + NotificationId, {}, {headers: auth.getHeaders()}).then((result) => {
        
      });
    },
    deleteNotification(NotificationId){
      var r = confirm('Deseja remover esta notificação?');
      if(r === true){
        this.notifications = this.notifications.filter(n => {
            return n.NotificationId != NotificationId;
        })
        this.$http.post(API.Notifications.delete + NotificationId, {}, {headers: auth.getHeaders()}).then((result) => {
          
        });
      }
    },
    getTimeAgo(timestamp)
    {
      return Functions.timeDifference(timestamp)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  h4{
    color: #00AE39;
    margin-bottom: 1px;
  }
  span{
    font-size: 15px;
  }
  .notifications-list{
    padding-bottom: 40px;
  }
  #markAsRead{
    margin-right: 5px;
  }
  .new{
    border: 2px solid #ccc;
    h5{
      font-family: 'RalewayBold';
    }
    p{
      font-family: 'RalewayBold';
    }
  }
  img{
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Notifications.vue